// Mock data para AdPulse Ad Health Score
// Reemplazar por llamada real al backend cuando /ai/health-score esté listo
// Estructura idéntica a la que devolverá el endpoint

export const mockHealthData = {
  account_score: 68,
  status: 'needs_improvement', // healthy | needs_improvement | critical
  narrative: 'Tu cuenta tiene problemas de fatiga creativa y una campaña está quemando presupuesto. Hay 2 oportunidades claras de escalado.',
  pillars: {
    creatives: { score: 55, status: 'critical' },
    performance: { score: 72, status: 'needs_improvement' },
    audience: { score: 60, status: 'needs_improvement' },
    spend: { score: 80, status: 'healthy' },
  },
  quick_wins: [
    {
      id: 'qw1',
      action: 'Pausar campaña "Retargeting Q4"',
      reason: 'ROAS 0.9, gasta $420/día',
      impact: 'high',
    },
    {
      id: 'qw2',
      action: 'Subir +20% presupuesto en "Prospecting LAL 3%"',
      reason: 'ROAS 3.4, escalable',
      impact: 'high',
    },
    {
      id: 'qw3',
      action: 'Refrescar creativos en "Awareness Mayo"',
      reason: 'Frecuencia 4.8, CTR cayó 32%',
      impact: 'medium',
    },
  ],
  campaigns: [
    {
      id: 'c1',
      name: 'Retargeting Q4',
      score: 34,
      status: 'critical',
      spend_per_day: 420,
      roas: 0.9,
      ctr: 0.7,
      frequency: 3.2,
    },
    {
      id: 'c2',
      name: 'Awareness Mayo',
      score: 58,
      status: 'needs_improvement',
      spend_per_day: 180,
      roas: 1.6,
      ctr: 0.9,
      frequency: 4.8,
    },
    {
      id: 'c3',
      name: 'Prospecting Intereses',
      score: 66,
      status: 'needs_improvement',
      spend_per_day: 250,
      roas: 1.8,
      ctr: 1.1,
      frequency: 2.3,
    },
    {
      id: 'c4',
      name: 'Prospecting LAL 3%',
      score: 87,
      status: 'healthy',
      spend_per_day: 90,
      roas: 3.4,
      ctr: 2.1,
      frequency: 1.8,
    },
  ],
  insights: [
    {
      id: 'i1',
      type: 'critical',
      category: 'wasted_budget',
      title: 'Estás perdiendo dinero',
      description: '$420/día en campaña con ROAS 0.9 (vs 2.1 promedio industria)',
      action: 'Pausá o reducí presupuesto -50%',
      campaign_id: 'c1',
      priority: 95,
    },
    {
      id: 'i2',
      type: 'warning',
      category: 'creative_fatigue',
      title: 'Fatiga creativa detectada',
      description: 'Frecuencia 4.8 + CTR cayó 32% en 7 días',
      action: 'Refrescá creativos en "Awareness Mayo"',
      campaign_id: 'c2',
      priority: 75,
    },
    {
      id: 'i3',
      type: 'warning',
      category: 'low_ctr',
      title: 'CTR bajo vs industria',
      description: '0.9% en e-commerce (promedio 1.5%–2.5%)',
      action: 'Probá nuevos hooks en los primeros 3 segundos',
      campaign_id: 'c2',
      priority: 60,
    },
    {
      id: 'i4',
      type: 'opportunity',
      category: 'scaling_opportunity',
      title: 'Oportunidad de escalado',
      description: '"LAL 3%" tiene ROAS 3.4 pero solo $90/día',
      action: 'Subí presupuesto +20% por 3 días',
      campaign_id: 'c4',
      priority: 80,
    },
  ],
};

// Helpers para el backend futuro
export const getScoreColor = (score) => {
  if (score >= 71) return 'success';
  if (score >= 41) return 'warning';
  return 'error';
};

export const getScoreLabel = (score) => {
  if (score >= 71) return 'Saludable';
  if (score >= 41) return 'Mejorable';
  return 'Crítico';
};
